import { API_REQUEST } from ".";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  allAssetsAPI,
  assetDetailAPI,
  homeAssetsAPI,
  publicAssetsAPI,
  userDetailAPI,
  reportAssetAPI,
  reportUserAPI,
  markAsMissingAPI,
  editAssetAPI,
  getCategoriesAPI,
  getSubCategoriesAPI,
  assetStatusAPI,
  deleteAssetImageAPI,
  promoteAssetPaymentAPI,
} from "../../routes/apiURL";

// fetch-all-assets
export const fetchAllAssets = createAsyncThunk(
  "fetch-all-assets",
  async (props) => {
    try {
      const response = await API_REQUEST({
        url: allAssetsAPI,
        method: "GET",
        params: props || {},
      });
      return response;
    } catch (error) {}
  },
);

// fetch-assets-detail
export const fetchAssetsDetail = createAsyncThunk(
  "fetch-assets-detail",
  async (props) => {
    try {
      const response = await API_REQUEST({
        url: assetDetailAPI + props,
        method: "GET",
      });
      return response;
    } catch (error) {}
  },
);
// fetch-user-detail
export const fetchUserDetail = createAsyncThunk(
  "fetch-user-detail",
  async (props) => {
    try {
      const response = await API_REQUEST({
        url: userDetailAPI + props,
        method: "GET",
      });
      return response;
    } catch (error) {}
  },
);

// fetch-public-assets
export const fetchPublicAssets = createAsyncThunk(
  "fetch-public-assets",
  async (props) => {
    try {
      const response = await API_REQUEST({
        url: publicAssetsAPI,
        method: "GET",
        params: props || {},
      });
      return response;
    } catch (error) {}
  },
);

// fetch-home-assets
export const fetchHomeAssets = createAsyncThunk(
  "fetch-home-assets",
  async (props) => {
    try {
      const response = await API_REQUEST({
        url: homeAssetsAPI,
        method: "GET",
        params: props || {},
      });
      return response;
    } catch (error) {}
  },
);

// report-asset
export const reportAssetAction = createAsyncThunk(
  "report-asset",
  async (props, { rejectWithValue }) => {
    try {
      const response = await API_REQUEST({
        url: reportAssetAPI,
        method: "POST",
        data: props,
      });
      return response;
    } catch (error) {
      return rejectWithValue(error?.data || { message: error?.message || "Failed to report asset" });
    }
  },
);

// report-user
export const reportUserAction = createAsyncThunk(
  "report-user",
  async (props, { rejectWithValue }) => {
    try {
      const response = await API_REQUEST({
        url: reportUserAPI,
        method: "POST",
        data: props,
      });
      return response;
    } catch (error) {
      return rejectWithValue(error?.data || { message: error?.message || "Failed to report user" });
    }
  },
);

// mark-as-missing
export const markAsMissingAction = createAsyncThunk(
  "mark-as-missing",
  async (props, { rejectWithValue }) => {
    try {
      const response = await API_REQUEST({
        url: markAsMissingAPI,
        method: "POST",
        data: props,
      });
      return response;
    } catch (error) {
      return rejectWithValue(
        error?.data || { message: error?.message || "Failed to mark asset as missing" }
      );
    }
  },
);

// edit-asset
export const editAssetAction = createAsyncThunk(
  "edit-asset",
  async (props, { rejectWithValue }) => {
    try {
      const response = await API_REQUEST({
        url: editAssetAPI,
        method: "POST",
        data: props,
      });
      return response;
    } catch (error) {
      return rejectWithValue(
        error?.data || { message: error?.message || "Failed to update asset" }
      );
    }
  },
);

// fetch-categories
export const fetchCategoriesAction = createAsyncThunk(
  "fetch-categories",
  async (_, { rejectWithValue }) => {
    try {
      const response = await API_REQUEST({
        url: getCategoriesAPI,
        method: "GET",
        isSuccessToast: false,
      });
      return response;
    } catch (error) {
      return rejectWithValue(
        error?.data || { message: error?.message || "Failed to fetch categories" }
      );
    }
  },
);

// fetch-sub-categories
export const fetchSubCategoriesAction = createAsyncThunk(
  "fetch-sub-categories",
  async (categoryId, { rejectWithValue }) => {
    try {
      const response = await API_REQUEST({
        url: getSubCategoriesAPI + categoryId,
        method: "GET",
        isSuccessToast: false,
      });
      return response;
    } catch (error) {
      return rejectWithValue(
        error?.data || { message: error?.message || "Failed to fetch sub-categories" }
      );
    }
  },
);

// fetch-asset-status
export const fetchAssetStatusAction = createAsyncThunk(
  "fetch-asset-status",
  async (_, { rejectWithValue }) => {
    try {
      const response = await API_REQUEST({
        url: assetStatusAPI,
        method: "GET",
        isSuccessToast: false,
      });
      return response;
    } catch (error) {
      return rejectWithValue(
        error?.data || { message: error?.message || "Failed to fetch asset status" }
      );
    }
  },
);

// delete-asset-image
export const deleteAssetImageAction = createAsyncThunk(
  "delete-asset-image",
  async (imageId, { rejectWithValue }) => {
    try {
      const response = await API_REQUEST({
        url: deleteAssetImageAPI + imageId,
        method: "DELETE",
        isSuccessToast: true,
      });
      return response;
    } catch (error) {
      return rejectWithValue(
        error?.data || { message: error?.message || "Failed to delete asset image" }
      );
    }
  },
);

// promote-asset-checkout
export const promoteAssetCheckoutAction = createAsyncThunk(
  "promote-asset-checkout",
  async ({ assetId, weeks }, { rejectWithValue }) => {
    try {
      const response = await API_REQUEST({
        url: promoteAssetPaymentAPI,
        method: "POST",
        data: {
          assetId: Number(assetId),
          weeks: Number(weeks),
        },
        isSuccessToast: false,
        isErrorToast: true,
      });
      return response;
    } catch (error) {
      return rejectWithValue(
        error?.data || { message: error?.message || "Failed to create promote checkout session" }
      );
    }
  }
);
